export default ({ request }) => ({
  planOrderScheduleTreeApi(params = {}) {
    return request({
      url: '/factory/plan/orderSchedule/tree',
      method: 'GET',
      params,
    })
  },
})
